exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-divider--horizontal[data-v-37dfd6fc] {\n  margin-bottom: 4px\n}\n.versionInfo[data-v-37dfd6fc] {\n  font-size: 10px;\n  color: #ccc;\n}\n", ""]);

// exports
